import { z } from 'zod';
export const jsonEditorField = z.preprocess(value => value === null || value === undefined ? [] : value, z.array(z.object({}).catchall(z.unknown()))).default([]);
export type JsonEditorField = z.infer<typeof jsonEditorField>;